/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CompanionSessionEntity,
  CreateCompanionSessionDto,
  InitializePasswordEmailResult,
  SessionEntity,
  SignInDto,
  UserAuthInfoEntity,
} from '../models/index';
import {
    CompanionSessionEntityFromJSON,
    CompanionSessionEntityToJSON,
    CreateCompanionSessionDtoFromJSON,
    CreateCompanionSessionDtoToJSON,
    InitializePasswordEmailResultFromJSON,
    InitializePasswordEmailResultToJSON,
    SessionEntityFromJSON,
    SessionEntityToJSON,
    SignInDtoFromJSON,
    SignInDtoToJSON,
    UserAuthInfoEntityFromJSON,
    UserAuthInfoEntityToJSON,
} from '../models/index';

export interface CreateCompanionSessionRequest {
    createCompanionSessionDto: CreateCompanionSessionDto;
}

export interface SendInitializePasswordEmailRequest {
    email: string;
}

export interface SignInWithEmailAndPasswordRequest {
    signInDto: SignInDto;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * 呼び出し元セッションとは独立したリフレッシュトークンのチェーンを持つ新規セッションを発行し、トークンペアを返す。返却されたリフレッシュトークンは呼び出し元がサーバー間で安全に保管すること。同一 auth tenant × ユーザー × sessionName の companion セッションは常に1本で、同名で再発行すると旧セッションは失効する（置き換え）。auth tenant 内のユーザーあたり companion セッション総数は10本が上限で、超過時は 400 を返す。アクセストークンペイロードの sessionName キーは companion セッション専用の予約キーであり、通常セッションでは使用しない。
     * 外部連携向けに、現在のユーザーの独立した新規セッション（companion セッション）をもう1本発行する。
     */
    async createCompanionSessionRaw(requestParameters: CreateCompanionSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompanionSessionEntity>> {
        if (requestParameters['createCompanionSessionDto'] == null) {
            throw new runtime.RequiredError(
                'createCompanionSessionDto',
                'Required parameter "createCompanionSessionDto" was null or undefined when calling createCompanionSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/session/companion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanionSessionDtoToJSON(requestParameters['createCompanionSessionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompanionSessionEntityFromJSON(jsonValue));
    }

    /**
     * 呼び出し元セッションとは独立したリフレッシュトークンのチェーンを持つ新規セッションを発行し、トークンペアを返す。返却されたリフレッシュトークンは呼び出し元がサーバー間で安全に保管すること。同一 auth tenant × ユーザー × sessionName の companion セッションは常に1本で、同名で再発行すると旧セッションは失効する（置き換え）。auth tenant 内のユーザーあたり companion セッション総数は10本が上限で、超過時は 400 を返す。アクセストークンペイロードの sessionName キーは companion セッション専用の予約キーであり、通常セッションでは使用しない。
     * 外部連携向けに、現在のユーザーの独立した新規セッション（companion セッション）をもう1本発行する。
     */
    async createCompanionSession(requestParameters: CreateCompanionSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompanionSessionEntity> {
        const response = await this.createCompanionSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * パスワードをリセットする。
     */
    async createResetPasswordLinkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/createResetPasswordLink`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * パスワードをリセットする。
     */
    async createResetPasswordLink(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createResetPasswordLinkRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分自身のユーザー認証情報を取得する。
     */
    async getMyUserAuthInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserAuthInfoEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/userAuthInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserAuthInfoEntityFromJSON(jsonValue));
    }

    /**
     * 自分自身のユーザー認証情報を取得する。
     */
    async getMyUserAuthInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserAuthInfoEntity> {
        const response = await this.getMyUserAuthInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * 現在サインイン中のセッション情報を取得する。
     */
    async getSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionEntityFromJSON(jsonValue));
    }

    /**
     * 現在サインイン中のセッション情報を取得する。
     */
    async getSession(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionEntity> {
        const response = await this.getSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自身のパスワードログインアカウントを作成し、初期パスワードをメールで送信する。
     */
    async sendInitializeMyPasswordEmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitializePasswordEmailResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/sendInitializePasswordEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitializePasswordEmailResultFromJSON(jsonValue));
    }

    /**
     * 自身のパスワードログインアカウントを作成し、初期パスワードをメールで送信する。
     */
    async sendInitializeMyPasswordEmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitializePasswordEmailResult> {
        const response = await this.sendInitializeMyPasswordEmailRaw(initOverrides);
        return await response.value();
    }

    /**
     * パスワードログインを設定していないユーザーのアカウントを作成し、初期パスワードをメールで送信する。
     */
    async sendInitializePasswordEmailRaw(requestParameters: SendInitializePasswordEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitializePasswordEmailResult>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling sendInitializePasswordEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/sendInitializePasswordEmail/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitializePasswordEmailResultFromJSON(jsonValue));
    }

    /**
     * パスワードログインを設定していないユーザーのアカウントを作成し、初期パスワードをメールで送信する。
     */
    async sendInitializePasswordEmail(requestParameters: SendInitializePasswordEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitializePasswordEmailResult> {
        const response = await this.sendInitializePasswordEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * メールアドレスとパスワードでサインインする。
     */
    async signInWithEmailAndPasswordRaw(requestParameters: SignInWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SessionEntity>> {
        if (requestParameters['signInDto'] == null) {
            throw new runtime.RequiredError(
                'signInDto',
                'Required parameter "signInDto" was null or undefined when calling signInWithEmailAndPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/signin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignInDtoToJSON(requestParameters['signInDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionEntityFromJSON(jsonValue));
    }

    /**
     * メールアドレスとパスワードでサインインする。
     */
    async signInWithEmailAndPassword(requestParameters: SignInWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SessionEntity> {
        const response = await this.signInWithEmailAndPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * サインアウトする（現在のセッションを破棄する）。
     */
    async signOutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/authentication/signout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * サインアウトする（現在のセッションを破棄する）。
     */
    async signOut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.signOutRaw(initOverrides);
    }

}
